import { Checkbox, CheckboxGroup } from '@arthur/ui'
import { Option } from '@common/types/global.types'
import { FieldValues, useController, UseControllerProps } from 'react-hook-form'

interface CheckboxInputProps<T extends FieldValues> extends UseControllerProps<T> {
	label?: string
	options: Option[]
}

/**
 * Checkbox input
 * @param control
 * @param name
 * @param label
 * @param options
 * @constructor
 */
const CheckboxInput = <T extends FieldValues>(
	{
		control,
		name,
		label,
		options
	}: CheckboxInputProps<T>
) => {
	const { field } = useController({ control, name })

	return (
		<CheckboxGroup
			legendId="checkbox-group"
			legendText={label ?? ''}
		>
			{options.map((option) => (
				<Checkbox
					key={option.value}
					id={option.value as string}
					labelText={option.label}
					onChange={(_, { checked }) => {
						field.onChange({ ...field.value, [option.value]: checked })
					}}
					checked={field.value[option.value]}
				/>
			))}
		</CheckboxGroup>
	)
}

export default CheckboxInput
